import {
  ADMINISTRATOR,
  CREDIT,
  ORDEM_COMPRA,
  PERMISSIONS,
} from "./permissions";

import AgentesIcon from "../assets/navbar/Agentes_on.svg";
import ConveniosIcon from "../assets/navbar/Convenios_on.svg";
import FrontCreditoIcon from "../assets/navbar/Front_Credito_on_light_blue.svg";
import OrdemCompraIcon from "../assets/navbar/Front_Credito_on_light_blue.svg";
import LojasIcon from "../assets/navbar/Lojas_on.svg";
import MotivosRejeicaoIcon from "../assets/navbar/Convenios_on.svg";
import PessoaFisicaIcon from "../assets/navbar/Pessoa_fisica_on.svg";
import PessoaJuridicaIcon from "../assets/navbar/Pessoa_juridica_on.svg";
import RegionalIcon from "../assets/navbar/Regional_on.svg";
import UserIcon from "../assets/navbar/Usuario_on.svg";
import { clearFilters } from "../components/ListCredit/reducer";

export const navigationPages = [
  {
    id: "usuario",
    path: "/usuario",
    icon: UserIcon,
    title: "Usuário",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "pessoa-fisica",
    path: "/pessoa-fisica",
    icon: PessoaFisicaIcon,
    title: "Pessoa física",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "pessoa-juridica",
    path: "/pessoa-juridica",
    icon: PessoaJuridicaIcon,
    title: "Pessoa jurídica",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "lojas",
    path: "/lojas",
    icon: LojasIcon,
    title: "Lojas",
    permissions: [ADMINISTRATOR],
    forceIconCorrection: true,
  },
  {
    id: "agentes",
    path: "/agentes",
    icon: AgentesIcon,
    title: "Agentes",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "regionais",
    path: "/regionais",
    icon: RegionalIcon,
    title: "Regional",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "convenios",
    path: "/convenios",
    icon: ConveniosIcon,
    title: "Convênios",
    permissions: [ADMINISTRATOR],
    forceIconCorrection: true,
  },
  {
    id: "motivos-rejeicao",
    path: "/motivos-rejeicao",
    icon: MotivosRejeicaoIcon,
    title: "Motivos Rejeição",
    permissions: [ADMINISTRATOR],
    forceIconCorrection: true,
  },
  {
    id: "front-de-credito",
    path: "/front-de-credito",
    icon: FrontCreditoIcon,
    title: "Front de Crédito",
    permissions: [CREDIT],
    onNavigation: (dispatch) => () => dispatch(clearFilters()),
    forceIconCorrection: true,
  },
  {
    id: "ordem-compra",
    path: "/ordem-compra",
    icon: OrdemCompraIcon,
    title: "Ordem de Compra",
    permissions: [ORDEM_COMPRA],
    forceIconCorrection: true,
  },
];

export const administrationPages = [
  {
    id: "whitelist",
    text: "Cadastro de administradores",
    link: "/whitelist",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "role-registration",
    text: "Cadastro de papéis",
    link: "/role-registration",
    permissions: [ADMINISTRATOR],
  },
  {
    id: "permissions-registration",
    text: "Cadastro de pemissões",
    link: "/permissions-registration",
    permissions: [PERMISSIONS],
  },
  {
    id: "parametros",
    text: "Editar parâmetros",
    link: "/parametros",
    permissions: [ADMINISTRATOR],
  },
];
